import React from 'react';
import styled from 'styled-components';
//
import InputTextarea from 'components/input/textarea';
import InputGroup from 'components/input/group';
import { Label as InputLabel, InputError } from 'components/formula-entry/modals/_common';
import InputText from 'components/input/text';
import { EDealField, IDeal, IDealValidationErrors } from 'store/deals/types';
import colors from 'theme/colors';
import { dealNameTestid, customerNameTestid, dealDescription } from 'components/sidebar/base-navigation/test-ids';
import FormControl from 'components/input/form-control';
import MenuItem from 'components/menu-item';
import Select from 'components/input/select';
import { IFieldOption, IFieldOptionState, OFFER_TYPES } from 'store/field-options/types';
import { validateName } from 'lib/validators/deal';
import ToolTip from 'components/i-tooltip';
import labels from 'constants/labels';

const { globalIcon } = colors;

interface INameAndDescriptionProps {
  updateDealField: Function;
  dealEdit: IDeal;
  fieldOptions: IFieldOptionState;
}

const OptionalLabel = styled.span`
  color: ${globalIcon};
`;

export default ({ dealEdit, fieldOptions, updateDealField }: INameAndDescriptionProps) => {
  const { customer, description, name, productLine = '', region = '', validationErrors, status, offerType } = dealEdit;
  const { productLines: availableProductLines, regions: availableRegions, statuses } = fieldOptions;

  // Check for validation errors
  const errors: IDealValidationErrors = {
    name: null,
    status: null,
  };
  if (validationErrors) {
    errors.status = validationErrors.status !== null && status === '' ? validationErrors.status : null;
    errors.name = validationErrors.name !== null && validateName(name) ? validationErrors.name : null;
  }

  return (
    <>
      <InputGroup>
        <InputLabel>CUSTOMER</InputLabel>
        <InputText
          placeholder=""
          value={customer}
          onChange={e => updateDealField(EDealField.CUSTOMER, e.target.value)}
          data-testid={customerNameTestid}
        />
      </InputGroup>
      <InputGroup>
        <InputLabel data-valid={!!errors.name}>DEAL NAME</InputLabel>
        <InputText
          placeholder=""
          value={name}
          onChange={e => updateDealField(EDealField.NAME, e.target.value)}
          data-testid={dealNameTestid}
        />
        <InputError>{errors.name}</InputError>
      </InputGroup>
      <InputGroup>
        <InputLabel>REGION</InputLabel>
        <FormControl variant="outlined" required>
          <Select
            labelId="select-label-region"
            id="select-region"
            value={region}
            onChange={e => updateDealField(EDealField.REGION, e.target.value)}
          >
            <MenuItem value="">Select region</MenuItem>
            {availableRegions?.map((availableRegion: IFieldOption) => (
              <MenuItem key={availableRegion.name} value={availableRegion.name}>
                {availableRegion.displayName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </InputGroup>
      <InputGroup>
        <InputLabel>PRODUCT LINE</InputLabel>
        <FormControl variant="outlined" required>
          <Select
            labelId="select-label-product-line"
            id="select-product-line"
            value={productLine}
            onChange={e => updateDealField(EDealField.PRODUCT_LINE, e.target.value)}
          >
            <MenuItem value="">Select product line</MenuItem>
            {availableProductLines?.map((availableProductLine: IFieldOption) => (
              <MenuItem key={availableProductLine.name} value={availableProductLine.name}>
                {availableProductLine.displayName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </InputGroup>
      <InputGroup>
        <InputLabel>
          DESCRIPTION <OptionalLabel>(OPTIONAL)</OptionalLabel>
        </InputLabel>
        <InputTextarea
          placeholder=""
          value={description ?? ''}
          onChange={e => updateDealField(EDealField.DESCRIPTION, e.target.value)}
          data-testid={dealDescription}
        />
      </InputGroup>
      <InputGroup>
        <InputLabel data-valid={!!errors.status}>
          STATUS
          <ToolTip top="5" placement="right" title={labels.tooltip.dealStatus} />
        </InputLabel>
        <FormControl variant="outlined" required>
          <Select
            labelId="select-label-status"
            id="select-status"
            value={status}
            onChange={e => updateDealField(EDealField.STATUS, e.target.value)}
          >
            <MenuItem value="">Select status</MenuItem>
            {statuses?.map((statusData: IFieldOption) => (
              <MenuItem key={statusData.name} value={statusData.name}>
                {statusData.displayName}
              </MenuItem>
            ))}
          </Select>
          <InputError>{errors.status}</InputError>
        </FormControl>
      </InputGroup>
      <InputGroup>
        <InputLabel>OFFER TYPE</InputLabel>
        <FormControl variant="outlined" required>
          <Select
            labelId="select-label-offer"
            id="select-offer"
            value={offerType}
            onChange={e => updateDealField(EDealField.OFFER_TYPE, e.target.value)}
          >
            <MenuItem value="">Select Offer type</MenuItem>
            {OFFER_TYPES?.map((offerTypeData: string) => (
              <MenuItem key={offerTypeData} value={offerTypeData}>
                {offerTypeData}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </InputGroup>
    </>
  );
};
